import { Base64 } from 'shared/types/global'

const PREVIEW_URLS_CACHE_KEY = 'pagePreviews'
const CACHE_URL_PREFIX = '/page-previews-cache/'

export const usePreviewsCache = () => {
  const previewsMap = localStorage.getItem(PREVIEW_URLS_CACHE_KEY)

  const cachePreview = async (key: string, blob: Blob) => {
    const newMap = {
      ...(previewsMap ? JSON.parse(previewsMap) : {}),
      [key]: Date.now()
    }
    localStorage.setItem(
      PREVIEW_URLS_CACHE_KEY,
      JSON.stringify(newMap)
    )

    const cache = await caches.open(PREVIEW_URLS_CACHE_KEY)
    const response = new Response(blob, {
      headers: { 'Content-Type': 'image/png' }
    })
    await cache.put(`${CACHE_URL_PREFIX}${key}`, response)
  }

  const getRawPreviewFromCache = async (key: string) => {
    const cache = await caches.open(PREVIEW_URLS_CACHE_KEY)
    return cache.match(`${CACHE_URL_PREFIX}${key}`)
  }

  const getPreviewFromCache = async (
    key: string,
    timestamp: Date | null
  ): Promise<Base64 | null> => {
    if (timestamp !== null) {
      if (!previewsMap) {
        return null
      }

      const mapTimestamp = new Date(JSON.parse(previewsMap)[key])

      if (mapTimestamp && mapTimestamp < timestamp) {
        return null
      }
    }

    const response = await getRawPreviewFromCache(key)
    if (!response) {
      return null
    }

    const blob = await response.blob() // Convert response to Blob
    const url = URL.createObjectURL(blob) // Generate a valid Blob URL
    return url
  }

  return { cachePreview, getPreviewFromCache, getRawPreviewFromCache }
}
